import Divider from '@material-ui/core/Divider';
import { makeStyles, styled } from '@material-ui/core/styles';

export const useProspectingAssistantModalStyles = makeStyles(theme => ({
  dialogPaper: {
    borderRadius: theme.shape.borderRadius,
    minHeight: '30dvh',
    maxHeight: '80dvh'
  },
  header: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between'
  },
  dialogContent: {
    padding: theme.spacing(4, 0, 2, 0)
  }
}));

export const DividerStyled = styled(Divider)(({ theme }) => ({
  margin: theme.spacing(2, 0)
}));
